var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0312 20.3288C41.0312 30.5211 33.4754 38.947 23.6605 40.3147C22.7425 40.4426 21.8035 40.5088 20.8506 40.5088C19.7501 40.5088 18.6705 40.4205 17.6177 40.2508C8.00962 38.7042 0.669922 30.3723 0.669922 20.3276C0.669922 9.18246 9.7051 0.147583 20.8506 0.147583C31.9961 0.147583 41.0312 9.18246 41.0312 20.3276V20.3288Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8437 32.5303C25.6455 27.5914 30.4472 23.1688 30.4472 17.7135C30.4472 12.2581 26.1476 7.83557 20.8437 7.83557C15.5399 7.83557 11.2402 12.2581 11.2402 17.7135C11.2402 23.1688 16.042 27.5914 20.8437 32.5303Z",
    stroke: "#051A2F",
    strokeWidth: 2.88295,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8396 20.1825C22.355 20.1825 23.5834 18.9541 23.5834 17.4387C23.5834 15.9233 22.355 14.6948 20.8396 14.6948C19.3241 14.6948 18.0957 15.9233 18.0957 17.4387C18.0957 18.9541 19.3241 20.1825 20.8396 20.1825Z",
    stroke: "#051A2F",
    strokeWidth: 2.88295,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.caf0c2db7a02ea7a6172b9337ceb6179.svg";
export { ForwardRef as ReactComponent };